module.exports = __webpack_public_path__ + "img/9788936456566.20e16046.jpg";